<template>
    <el-collapse-item class="SE_list_item list-group-item">
        <template #title>
            <div style="display:flex; flex-direction: column; width: 100%;">
                <strong>{{ entity.companyname }}</strong>
                <template v-if="entity.groups">
                    <span v-for="group in entity.groups">
                        {{ group.groupname }}
                    </span>
                </template>

            </div>
        </template>

        <div class="SE_auxiliaryname SE_item" v-if="(entity.auxiliaryname && entity.auxiliaryname.length) && isAnySpecialGroup()">
            <h4>{{ conf.labels.auxiliaryname }}</h4>
            <template v-if="entity.auxiliaryname && entity.auxiliaryname.length">
                <template v-for="aux in entity.auxiliaryname" :key="aux">
                    <span>{{ aux }}</span>
                    <br />
                </template>
            </template>
        </div>

        <div class="SE_marketingname SE_item" v-if="entity.marketingname && entity.marketingname.length && isAnySpecialGroup()">
            <h4>{{ conf.labels.marketingname }}</h4>
            <template v-for="name in entity.marketingname">
                <span>{{ name }}</span>
                <br />
            </template>

        </div>
        <div class="SE_contact_information SE_item"
             v-if="entity.wwwaddress || entity.telephone || entity.telefax || entity.postaladdress || entity.headofficeaddress || entity.officeaddress || entity.visitingaddress || entity.consumercomplaintsaddress">

            <div class="SE_item_info contactinformation">
                <h3>{{ conf.labels.contactinformation }}</h3>

                <div class="row contact-row" v-if="(entity.telephone && hasDisplayElement(displayStyle, displayElement.Telephone)) || (entity.telefax && hasDisplayElement(displayStyle, displayElement.Telefax))">
                    <template v-if="entity.telephone && hasDisplayElement(displayStyle, displayElement.Telephone)">
                        <div class="col-md-4">{{ conf.labels.telephone }}: {{ entity.telephone }}</div>
                    </template>
                    <template v-if="entity.telefax && hasDisplayElement(displayStyle, displayElement.Telefax)">
                        <div class="col-md-4">{{ conf.labels.telefax }}: {{ entity.telefax }}</div>
                    </template>
                </div>

                <template v-if="entity.postaladdress && entity.postaladdress.length && hasDisplayElement(displayStyle, displayElement.PostalAddress)">
                    <!--<h4>{{ conf.labels.postaladdress }}</h4>-->
                    <template v-for="item in entity.postaladdress">
                        <template v-if="item.address">
                            {{ item.address }}
                            <br />
                        </template>
                        <template v-if="item.address2">
                            {{ item.address2 }}
                            <br />
                        </template>
                        <template v-if="item.zipcode">
                            {{ item.zipcode }}&nbsp;
                        </template>
                        <template v-if="item.city">
                            {{ item.city }}
                            <br />
                        </template>
                        <template v-if="item.country">
                            {{ item.country }}
                            <br />
                        </template>

                    </template>
                </template>
                <template v-if="entity.wwwaddress && hasDisplayElement(displayStyle, displayElement.WWWAddress)">
                    <a :href="entity.wwwaddress">{{ entity.wwwaddress }}</a>
                    <br />
                </template>
                <template v-if="entity.headofficeaddress && entity.headofficeaddress.length && hasDisplayElement(displayStyle, displayElement.HeadOfficeAddress)">
                    <h4>{{ conf.labels.headofficeaddress }}</h4>
                    <template v-for="item in entity.headofficeaddress">
                        <template v-if="item.address">
                            {{ item.address }}
                            <br />
                        </template>
                        <template v-if="item.address2">
                            {{ item.address2 }}
                            <br />
                        </template>
                        <template v-if="item.zipcode">
                            {{ item.zipcode }}&nbsp;
                        </template>
                        <template v-if="item.city">
                            {{ item.city }}
                            <br />
                        </template>
                        <template v-if="item.country">
                            {{ item.country }}
                            <br />
                        </template>
                    </template>
                </template>
                <template v-if="entity.officeaddress && entity.officeaddress.length && hasDisplayElement(displayStyle, displayElement.OfficeAddress)">
                    <h4>{{ conf.labels.officeaddress }}</h4>
                    <template v-for="item in entity.officeaddress">
                        <template v-if="item.address">
                            {{ item.address }}
                            <br />
                        </template>
                        <template v-if="item.address2">
                            {{ item.address2 }}
                            <br />
                        </template>
                        <template v-if="item.zipcode">
                            {{ item.zipcode }}&nbsp;
                        </template>
                        <template v-if="item.city">
                            {{ item.city }}
                            <br />
                        </template>
                        <template v-if="item.country">
                            {{ item.country }}
                            <br />
                        </template>
                    </template>
                </template>
                <template v-if="entity.visitingaddress && entity.visitingaddress.length && hasDisplayElement(displayStyle, displayElement.VisitingAddress)">
                    <h4>{{ conf.labels.visitingaddress }}</h4>
                    <template v-for="item in entity.visitingaddress">
                        <template v-if="item.address">
                            {{ item.address }}
                            <br />
                        </template>
                        <template v-if="item.address2">
                            {{ item.address2 }}
                            <br />
                        </template>
                        <template v-if="item.zipcode">
                            {{ item.zipcode }}&nbsp;
                        </template>
                        <template v-if="item.city">
                            {{ item.city }}
                            <br />
                        </template>
                        <template v-if="item.country">
                            {{ item.country }}
                            <br />
                        </template>
                    </template>
                </template>
                <template v-if="entity.consumercomplaintsaddress && entity.consumercomplaintsaddress.length && hasDisplayElement(displayStyle, displayElement.ConsumerComplaintsAddress) && isAnySpecialGroup()">
                    <h4>{{ conf.labels.consumercomplaintsaddress }}</h4>
                    {{ entity.consumercomplaintsaddress }}
                </template>
            </div>
        </div>
        <div class="SE_personsincharge SE_item" v-if="entity.personsincharge && entity.personsincharge.length">
            <h4>{{ conf.labels.personsincharge }}</h4>
            <span v-for="person in entity.personsincharge">
                {{person.title}}: {{person.name}}
                <br />
            </span>

        </div>
        <div class="SE_supervisorsinfsa SE_item" v-if="entity.supervisorsinfsa && entity.supervisorsinfsa.length">
            <h4>{{ conf.labels.supervisorsinfsa }}</h4>
            <span v-for="(person, i) in entity.supervisorsinfsa" :key="i">
                {{person.name}}, {{ conf.labels.telephone }}: {{ person.telephonenumber }}
                <br />
            </span>
        </div>
        <div class="SE_authorisationsandotheroperationgrounds SE_item" v-if="entity.authorisationsandotheroperationgrounds && entity.authorisationsandotheroperationgrounds.length">
            <h4>{{ conf.labels.authorisationsandotheroperationgrounds }}</h4>
            <span v-for="auth in sortAlphabetically(entity.authorisationsandotheroperationgrounds, auth => auth.authorisationname || auth)">
                <template v-if="auth.authorisationname">
                    {{ auth.authorisationname }}
                </template>
                <template v-else>
                    {{ auth }}
                </template>
                <br />
            </span>
        </div>

        <template v-if="(entity.homestate === 'Finland' || entity.homestate === 'Suomi') && entity.businessidentitycode && entity.businessidentitycode.length">
            <div class="SE_businessidentitycode SE_item">
                <h4>{{ conf.labels.businessidentitycode }}</h4>
                {{ entity.businessidentitycode }}
            </div>
        </template>
        <template v-else-if="entity.businessidentitycode && entity.businessidentitycode.length">
            <div class="SE_businessidentitycode SE_item">
                <h4>{{ conf.labels.registernumberinhomestate }}</h4>
                {{ entity.businessidentitycode }}
            </div>
        </template>



        <div class="SE_legalentityidentifier SE_item" v-if="entity.legalentityidentifier && entity.legalentityidentifier.length && isAnySpecialGroup()">
            <h4>{{ conf.labels.legalentityidentifier }}</h4>
            {{ entity.legalentityidentifier }}
        </div>
        <div class="SE_legalentityidentifier SE_item" v-if="entity.registernumberinhomestate && entity.registernumberinhomestate.length && isInSupervisedSpecialGroups()">
            <h4>{{ conf.labels.registernumberinhomestate }}</h4>
            {{ entity.registernumberinhomestate }}
        </div>

        <div class="SE_homestate SE_item" v-if="entity.homestate && entity.homestate.length && !isSupervisedPage">
            <!-- For non-supervised pages -->
            <h4>{{ conf.labels.homestate }}</h4>
            {{ entity.homestate }}
        </div>
        <div class="SE_triangularpassport SE_item" v-if="entity.triangularpassport && entity.triangularpassport.length && !isSupervisedPage && isInNotificationsSpecialGroups">
            <!-- For non-supervised pages -->
            <h4>{{ conf.labels.triangularpassport }}</h4>
            {{ entity.triangularpassport }}
        </div>
        <div class="SE_dateofcreditservicerauthorisation SE_item" v-if="entity.dateofcreditservicerauthorisation && entity.dateofcreditservicerauthorisation.length && !isSupervisedPage && isAnySpecialGroup()">
            <!-- For non-supervised pages -->
            <h4>{{ conf.labels.dateofcreditservicerauthorisation }}</h4>
            {{ entity.dateofcreditservicerauthorisation }}
        </div>
        <div class="SE_dateofregistration SE_item" v-if="entity.dateofregistration && entity.dateofregistration.length && !isSupervisedPage && isAnySpecialGroup()">
            <!-- For non-supervised pages -->
            <h4>{{ conf.labels.dateofregistration }}</h4>
            {{ new Date(entity.dateofregistration).toLocaleDateString() }}
        </div>
        <div class="SE_providedservices SE_item" v-if="entity.providedservices && entity.providedservices.length">
            <h4>{{ conf.labels.providedservices }}</h4>
            <span v-for="service in sortAlphabetically(entity.providedservices, service=> service.servicename || service)">
                <template v-if="service.servicename">
                    {{ service.servicename }}
                </template>
                <template v-else>
                    {{ service }}
                </template>
                <br />
            </span>
        </div>
        <div class="SE_funds SE_item" v-if="entity.funds && entity.funds.length">
            <!-- If it belongs to group 2200, change the header to 'sidonnaisasiamiehet' -->
            <h4 v-if="entity.groups.some(group => group.groupnumber === 2200)">
                {{ conf.labels.tiedagents }}
            </h4>
            <h4 v-else-if="entity.groups.filter(group => differentFundGroups.includes(group))">
                {{ conf.labels.funds2 }}
            </h4>
            <h4 v-else>{{ conf.labels.funds }}</h4>
            <div class="SE_item_info">
                <div class="fund clearfix" v-for="fund in entity.funds">
                    <span v-if="fund.fundname">{{ fund.fundname }}</span> <span v-if="fund.fundtype">{{ fund.fundtype }}</span>

                </div>
            </div>

        </div>
        <div class="SE_principalofanagent SE_item" v-if="entity.principalofanagent && entity.principalofanagent.length">
            <h4>{{ conf.labels.principalofanagent }}</h4>
            <span v-for="principal in sortAlphabetically(entity.principalofanagent, principal=> principal.principalname || principal)">
                <template v-if="principal.principalname">
                    {{ principal.principalname }}
                </template>
                <template v-else>
                    {{ principal }}
                </template>
                <br />
            </span>

        </div>
        <div class="SE_tiedagents SE_item" v-if="entity.tiedagents && entity.tiedagents.length">
            <h4>{{ conf.labels.tiedagents }}</h4>
            <el-collapse v-if="entity.tiedagents && entity.tiedagents.length">
                <el-collapse-item v-for="(item, i) in entity.tiedagents" :title="item.tiedagentname" :key="i">
                    <div class="SE_tied_agent active">
                        <div class="SE_tied_agent_info">
                            <div class="row" v-if="item.tiedagentidentitycode && item.tiedagentidentitycode.length">
                                <div class="col-xs-12 col-md-6">{{ conf.labels.tiedagent_tiedagentidentitycode }}</div>
                                <div class="col-xs-12 col-md-6">{{ item.tiedagentidentitycode }}</div>
                            </div>
                            <div class="row" v-if="item.streetaddress && item.streetaddress.length">
                                <div class="col-xs-12 col-md-6">{{ conf.labels.tiedagent_streetaddress }}</div>
                                <div class="col-xs-12 col-md-6">{{ item.streetaddress }}</div>
                            </div>
                            <div class="row" v-if="item.zipcode && item.zipcode.length">
                                <div class="col-xs-12 col-md-6">{{ conf.labels.tiedagent_zipcode }}</div>
                                <div class="col-xs-12 col-md-6">{{ item.zipcode }}</div>
                            </div>
                            <div class="row" v-if="item.homestate && item.homestate.length">
                                <div class="col-xs-12 col-md-6">{{ conf.labels.tiedagent_homestate }}</div>
                                <div class="col-xs-12 col-md-6">{{ item.homestate }}</div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    <ul class="SE_provided_services"
                                        v-if="item.placefinancialinstrumentstoclients ||
                                        item.promotetheinvestmentandancillaryservicesofinvestmentfirmtoclients ||
                                        item.provideinvestmentandancillaryservicesoradviceinrespectoffinancialinstrumentsofferedbytheinvestmentfirmtoclients ||
                                        item.receiveandtransmitinstructionsandordersfromtheclientsinrespectofinvestmentandancillaryservicesorfinancialinstruments">
                                        <li v-if="item.placefinancialinstrumentstoclients">
                                            {{ conf.labels.tiedagent_placefinancialinstrumentstoclients }}
                                        </li>
                                        <li v-if="item.promotetheinvestmentandancillaryservicesofinvestmentfirmtoclients">
                                            {{ conf.labels.tiedagent_promotetheinvestmentandancillaryservicesofinvestmentfirmtoclients }}
                                        </li>
                                        <li v-if="item.provideinvestmentandancillaryservicesoradviceinrespectoffinancialinstrumentsofferedbytheinvestmentfirmtoclients">
                                            {{ conf.labels.tiedagent_provideinvestmentandancillaryservicesoradviceinrespectoffinancialinstrumentsofferedbytheinvestmentfirmtoclients }}
                                        </li>
                                        <li v-if="item.receiveandtransmitinstructionsandordersfromtheclientsinrespectofinvestmentandancillaryservicesorfinancialinstruments">
                                            {{ conf.labels.tiedagent_receiveandtransmitinstructionsandordersfromtheclientsinrespectofinvestmentandancillaryservicesorfinancialinstruments }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                    </div>

                </el-collapse-item>
            </el-collapse>
        </div>
        <div class="SE_servicesdescription SE_item" v-if="entity.servicesdescription && entity.servicesdescription.length">
            <h4>{{ conf.labels.servicesdescription }}</h4>
            <span>
                {{ entity.servicesdescription }} <br />
            </span>
        </div>
        <div class="SE_dateofcreditservicerauthorisation SE_item" v-if="entity.dateofcreditservicerauthorisation && entity.dateofcreditservicerauthorisation.length && isSupervisedPage && isAnySpecialGroup()">
            <!-- For supervised pages only -->
            <h4>{{ conf.labels.dateofcreditservicerauthorisation }}</h4>
            {{ entity.dateofcreditservicerauthorisation }}
        </div>

        <div class="SE_dateofregistration SE_item" v-if="entity.dateofregistration && entity.dateofregistration.length && isSupervisedPage">
            <!-- For supervised pages only -->
            <h4>{{ conf.labels.dateofregistration }}</h4>
            <span>
                {{ new Date(entity.dateofregistration).toLocaleDateString()  }} <br />
            </span>
        </div>
        <div class="SE_homestate SE_item" v-if="entity.homestate && entity.homestate.length && isSupervisedPage">
            <!-- For supervised pages only -->
            <h4>{{ conf.labels.homestate }}</h4>
            {{ entity.homestate }}
        </div>
        <div class="SE_remarks SE_item" v-if="entity.remarks && entity.remarks.length && !isSupervisedPage && isInNotificationsSpecialGroups">
            <!-- For non-supervised pages -->
            <h4>{{ conf.labels.remarks }}</h4>
            {{ entity.remarks }}
        </div>
        <div class="SE_servicesincountry SE_item" v-if="entity.servicesincountry && entity.servicesincountry.length && !isSupervisedPage">
            <h4>{{ conf.labels.servicesincountry }}</h4>
            <el-collapse v-if="entity.servicesincountry && entity.servicesincountry.length">
                <el-collapse-item v-for="(item, i) in sortServicesInCountry(entity)" :key="i" :title="item.lang">
                    <span v-for="service in item.services">
                        {{ service }}<br />
                    </span>
                </el-collapse-item>

            </el-collapse>
        </div>

    </el-collapse-item>

</template>

<script>
    import { mapState, mapGetters } from "vuex";
    import { ref, computed } from 'vue';

    export default {
        data: () => ({
            differentFundGroups: [4889, 5000, 5001, 5002, 5003, 5004, 5005, 5006, 5007, 5008, 5009, 5010, 5011, 5012, 5021],
            displayStyle: 0

        }),
        methods: {
            sortAlphabetically(list, propToSortBy) {
                return list.sort((a, b) => {
                    var x = propToSortBy(a).toLowerCase();
                    var y = propToSortBy(b).toLowerCase();
                    if (x < y) { return -1; }
                    if (x > y) { return 1; }
                    return 0;
                })
            },
            sortServicesInCountry(item) {
                if (this.countries && this.countries.length) {
                    let _countries = item["servicesincountry"].reduce((accumulator, currentValue) => {
                        if (accumulator.indexOf(currentValue.countrycode) < 0)
                            accumulator.push(currentValue.countrycode)

                        return accumulator;
                    }, []);

                    let output = _countries.reduce((accumulator, currentValue) => {
                        accumulator[currentValue] = item["servicesincountry"].filter(x => x.countrycode === currentValue).map(x => x.servicename);
                        return accumulator;
                    }, {});

                    let sorted = [];

                    const countries = this.countries;
                    const countryLanguages = this.countryLanguages;
                    const language = this.conf.language;

                    Object.keys(output).forEach(function (key) {
                        var country = countries.find(x => x.countrycode === key);
                        let _lang = countryLanguages[language];
                        var lang = country ? country["countryname" + _lang] : key;
                        sorted.push({ lang: lang, services: output[key] });
                    });

                    sorted.sort((a, b) => a.lang.localeCompare(b.lang));

                    return sorted;
                } else return "";

            },
            focusFirstResult() {
                this.$nextTick(() => {
                    if (this.$refs.firstResultElement) {
                        this.$refs.firstResultElement.focus();
                    }
                });
            },
            hasDisplayElement(displayStyle, element) {
                return (displayStyle & element) === element;
            },
            getDisplayStyleForItem(item) {
                if (!item || !item.groups || item.groups.length === 0) return 0;

                let minDisplayStyle = null;

                if (this.ids.length) {
                    this.ids.forEach(g => {
                        const groupNumber = Number(g);
                        if (isNaN(groupNumber)) return;

                        const style = Number(this.groupDisplayMap[groupNumber]);
                        if (isNaN(style) || style <= 0) return;

                        if (minDisplayStyle === null || style < minDisplayStyle) {
                            minDisplayStyle = style;
                        }
                    });
                } else {
                    item.groups.forEach(g => {
                        const groupNumber = Number(g.groupnumber);
                        if (isNaN(groupNumber)) return;

                        const style = Number(this.groupDisplayMap[groupNumber]);
                        if (isNaN(style) || style <= 0) return;

                        if (minDisplayStyle === null || style < minDisplayStyle) {
                            minDisplayStyle = style;
                        }
                    });
                }

                console.log("display style", minDisplayStyle);
                return minDisplayStyle;
            },
            isInSupervisedSpecialGroups() {
                console.log("called supervised check");
                console.log("entity groups:", this.entity?.groups);
                console.log("supervisedSpecialGroups:", this.conf.supervisedSpecialGroups);
                if (!this.entity?.groups?.length || !this.conf.supervisedSpecialGroups?.length) return false;

                const allowed = new Set(JSON.parse(this.conf.supervisedSpecialGroups).map(Number));
                console.log(allowed);
                return this.entity.groups.some(g => {
                    const n = Number(g.groupnumber ?? g);
                    console.log(allowed.has(n));
                    return allowed.has(n);
                });
            },
            isInNotificationsSpecialGroups() {
                console.log("called notifications check");
                console.log("entity groups:", this.entity?.groups);
                console.log("notificationsSpecialGroups:", this.conf.notificationsSpecialGroups);
                if (!this.entity?.groups?.length || !this.conf.notificationsSpecialGroups?.length) return false;

                const allowed = new Set(JSON.parse(this.conf.notificationsSpecialGroups).map(Number));
                console.log(allowed);
                return this.entity.groups.some(g => {
                    const n = Number(g.groupnumber ?? g);
                    console.log(allowed.has(n));
                    return allowed.has(n);
                });
            },
            // Kuuluu isInSupervisedSpecialGroups tai isInNotificationsSpecialGroups, jolloin yhtenev�t laajennetut tiedot: Aputoiminimi, Markkinointinimi, Yhteystiedot kuluttajien valitusten k�sittelyyn, Lei-Koodi
            isAnySpecialGroup() {
                return this.isInSupervisedSpecialGroups() || this.isInNotificationsSpecialGroups();
            }
        },
        created() {
            this.displayStyle = this.getDisplayStyleForItem(this.entity);
            
        },
        props: {
            entity: Object,
        },
        computed: {
            ...mapState(["conf",
                "countries",
                "countryLanguages",
                "isSupervisedPage",
                "groupDisplayMap",
                "displayElement",
                "ids",
                "supervisedSpecialGroups",
                "notificationsSpecialGroups"
            ]),
            ...mapGetters(["createServicesInCountry",
                'firstResult'
            ]),
        }
    }
</script>

<style lang="scss" scoped>
</style>